export default __webpack_public_path__ + "static/belanja-kertas-ongkir-bebas-bfb65ff500ba9822b3dbf34b635e879a.png";